module.exports = __webpack_public_path__ + "img/icon-fzbd.783846bc.png";